import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DataTableAccountTransactions from "./DataTableAccountTransactions";

const DetailsSoldeClient = ({ startLoading, stopLoading }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [listTransaction, setListTransaction] = useState([]);
  const [tier, setTier] = useState();
  const [tierAccount, setTierAccount] = useState();


  useEffect(() => {
    startLoading();
      TierAccountService.findTransactionByAccount(
        getCurrentUserId(),
        localStorage.getItem("idAccountSolde")
      )
        .then((response) => {
          setListTransaction(response.data);
          setTier(response.data[0].tier)
          setTierAccount(response.data[0].tiersAccount)
        })
        .catch((error) => {
          setAlertMessage("error " + error);
        })
        .finally(() => {
          stopLoading();
        });

        // TierAccountService.getWalletByTier(getCurrentUserId(), localStorage.getItem("idTiers"))
        // .then((response) => {
        //   setSoldeInfo(response.data.success);
        //   setBtnSoldeClicked(true);
        // })
        // .catch((error) => {
        //   setAlertMessage("error " + error);
        // })
        // .finally(() => {
        //   stopLoading();
        // });
    }, []);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
              {tier && ( <div class="card-body">
                <h4 class="card-title">La société : {tier?.title} </h4>
                <br />
                <br />
                             
                  <p>Matricule :{tier.matricule} / {tier.codeCategorie} / {tier.codeTVA} / {tier.numberEtabSecondaire}</p>
                  <p>Adresse :{tier.adresse}</p>
                  {/* {tierAccount&&tierAccount?.type===2
 (<p>Solde :{tierAccount?.solde}</p>)}
     {tierAccount&&tierAccount?.type===3
 (<p>Solde :{tierAccount?.solde}</p>)} */}

                 {tierAccount&& (<p>Solde :{tierAccount?.solde}</p>)}

                   </div>
                )

                }
             </div>

              {listTransaction.length!==0 && (
                <DataTableAccountTransactions
                  listTransaction={listTransaction}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(DetailsSoldeClient);
